import { createSelector } from 'reselect';
import { FileState } from './types';

const selectFileState = (state: { file: FileState }) => state.file;

export const selectFileBlob = createSelector(
  selectFileState,
  (state) => state.fileBlob
);

export const selectFileLoading = createSelector(
  selectFileState,
  (state) => state.loading
);

export const selectFileError = createSelector(
  selectFileState,
  (state) => state.error
);
